//Install
import React, { Component } from "react";
//Install
import propTypes from "prop-types";

//Element
class E3Z06E extends Component {
    //Element
    render() {
        //Element
        const { ID, Title, Target } = this.props
        //Element
        const Content = React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB k3j22p" },
            //Element
            React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB kb249g", href: Target },
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p4e363" },
                    //Element
                    React.createElement("span", { className: "S6pt64 pEO064 a527eB d721Vx w5983g" },
                        //Element
                        Title
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
E3Z06E.propTypes = {
    ID: propTypes.string.isRequired,
    Title: propTypes.string.isRequired,
    Target: propTypes.string.isRequired
}
//Element
export default E3Z06E;